import {
    useCallback,
} from 'react'

import {
    LocationObjectSelector,
} from 'app/shared-components/LocationSelector'

import {
    RouteSelectionType,
} from '../../simulation.types'

import useSharedStyles from '../RouteSelection.styles'
import useStyles from './AirportsRoute.style'
import RouteViaAirport from './RouteViaAirport'

type Event = {
    target: {
        name: string,
        value: { id: number } | { id: number }[],
    }
}

type Props = {
    value: RouteSelectionType,
    onChange: (newVal: RouteSelectionType, event: {
        target: {
            name: string,
            value: RouteSelectionType,
        }
    }) => void,
    name: string,
}

const AirportsRoute = ({
    onChange,
    value,
    name,
}: Props) => {
    const {
        routeOriginAirport,
        routeViaAirports,
        routeDestinationAirport,
    } = value

    const {
        classes,
    } = useStyles()
    const {
        classes: sharedClasses,
    } = useSharedStyles()

    const onChangeSelection = useCallback((_, {
        target: {
            name: inputName,
            value: newValue,
        },
    }: Event): void => {
        onChange({
            ...value,
            [inputName]: newValue,
        }, {
            target: {
                value: {
                    ...value,
                    [inputName]: newValue,
                },
                name,
            },
        })
    }, [
        name,
        onChange,
        value,
    ])

    return (
        <div>
            <div className={sharedClasses.item}>
                <div className={sharedClasses.containerIcon}>
                    <div className={classes.circle} />
                    <div className={sharedClasses.verticalLine} />
                    <div className={sharedClasses.verticalLine} />
                    <div className={sharedClasses.verticalLine} />
                </div>
                <LocationObjectSelector
                    filterLocationType="AIRPORT"
                    name="routeOriginAirport"
                    value={routeOriginAirport}
                    onChange={onChangeSelection}
                    className={sharedClasses.locationInput}
                    classNames={{
                        label: sharedClasses.label,
                        labelContainer: sharedClasses.labelContainer,
                    }}
                    title="Origin Airport"
                    required
                />
            </div>
            <RouteViaAirport
                name="routeViaAirports"
                value={routeViaAirports}
                onChange={onChangeSelection}
            />
            <div className={sharedClasses.item}>
                <div className={sharedClasses.containerIcon}>
                    <img
                        className={classes.iconLocation}
                        alt="location"
                        src="/assets/images/icons/location.svg"
                    />
                </div>
                <LocationObjectSelector
                    name="routeDestinationAirport"
                    value={routeDestinationAirport}
                    onChange={onChangeSelection}
                    className={sharedClasses.locationInput}
                    classNames={{
                        label: sharedClasses.label,
                        labelContainer: sharedClasses.labelContainer,

                    }}
                    title="Destination Airport"
                    filterLocationType="AIRPORT"
                    required
                />
            </div>
        </div>
    )
}

export default AirportsRoute
